const OCI_LICENSE_TYPE_REQUIRES_WINDOWS_ERROR =
  'Operating system in OCI is not defined as Windows';

export const LICENSE_TYPE_REQUIRES_WINDOWS_KEY =
  'LICENSE_TYPE_REQUIRES_WINDOWS_KEY';

type ApiErrorResponse = {
  response?: {
    data?: {
      errors?: {
        provider_data?: {
          license_type?: string[];
        };
      };
    };
  };
};

const getLicenseTypeErrors = (error: unknown): string[] | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const { response } = error as ApiErrorResponse;

  return response?.data?.errors?.provider_data?.license_type;
};

export const isOciLicenseTypeRequiresWindowsError = (
  error: unknown
): boolean => {
  const licenseTypeErrors = getLicenseTypeErrors(error);

  return (
    Array.isArray(licenseTypeErrors) &&
    licenseTypeErrors.some(message =>
      message.includes(OCI_LICENSE_TYPE_REQUIRES_WINDOWS_ERROR)
    )
  );
};

export const getEditModelErrorMessageKey = (error: unknown): string | null =>
  isOciLicenseTypeRequiresWindowsError(error)
    ? LICENSE_TYPE_REQUIRES_WINDOWS_KEY
    : null;
